import { forwardRef, useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import { projects } from "../data/projectsData";
import "../styles/projects.css";

/* Intro choreography refinement: replaced the implicit-return version with a stateful intro observer.
export const Projects = forwardRef((_props, projectsSection) => (
  <section className="projects" id="projects" ref={projectsSection}>
    <div className="projects__bg" aria-hidden="true" />

    <Container fluid className="projects__fluid px-lg-0 px-3">
      <Row className="justify-content-center projects__row">
        <Col lg={10} className="projects__col">
          <div className="projects__inner">

            <div className="projects__intro">
              <p className="projects__eyebrow">SELECTED WORK</p>
              <h2 className="projects__heading">Things I've built</h2>
              <p className="projects__subhead">
                A selection of projects spanning full-stack applications,
                custom frontend systems, and backend services.
              </p>
            </div>

            <div className="projects__list">
              {projects.map((project, index) => (
                <ProjectCard project={project} index={index} key={project.id} />
              ))}
            </div>

          </div>
        </Col>
      </Row>
    </Container>
  </section>
));
*/

export const Projects = forwardRef((_props, projectsSection) => {
  const introRef = useRef(null);
  const [introVisible, setIntroVisible] = useState(false);

  useEffect(() => {
    const el = introRef.current;
    if (!el || !("IntersectionObserver" in window)) {
      setIntroVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIntroVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "0px 0px -10% 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="projects" id="projects" ref={projectsSection}>
      <div className="projects__bg" aria-hidden="true" />

      <Container fluid className="projects__fluid px-lg-0 px-3">
        <Row className="justify-content-center projects__row">
          <Col lg={10} className="projects__col">
            <div className="projects__inner">

              <div
                className={`projects__intro${introVisible ? " is-visible" : ""}`}
                ref={introRef}
              >
                <p className="projects__eyebrow">SELECTED WORK</p>
                <h2 className="projects__heading">Things I've built</h2>
                <p className="projects__subhead">
                  A selection of projects spanning full-stack applications,
                  custom frontend systems, and backend services.
                </p>
              </div>

              <div className="projects__list">
                {projects.map((project, index) => (
                  <ProjectCard project={project} index={index} key={project.id} />
                ))}
              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
});
